import constructVideoSeriesCarousel from '../../hocs/carousel/video_series_carousel';
import Episode from './episode';
import {get} from 'lodash';

export default constructVideoSeriesCarousel({

  slideType: 'episode',

  slideComponent: Episode,

  slideProps({ id, ...slide }, idx) {
    return {
      ...slide,
      idx,
      isActive: id === this.props.entryId
    };
  },

  uuid() {
    return get(this.props, 'slides[0].id');
  },

  intl() {
    return get(this.props, 'intl');
  }

});
